<script>
		import {user, game, view, send_data, send_request} from "../client.svelte.js";
		import {impactHue, bonusToString, timestamp} from "../core.js";
		import Input from "../elements/Input.svelte";
		import {onMount} from "svelte";

		let dialog      // this HTML element
		let { effect, coord, modal = false } = $props()

		const effcolor = `hsl(${impactHue[effect.kind]} 50% 50%)`
		let cause = $derived(game.activities.get(effect.cause))
		let progress = $derived(Math.round(Math.min(Math.max(0, (game.time - effect.begin) / (effect.end - effect.begin) * 100), 100)))

		onMount( () => (modal) ? dialog.showModal() : dialog.show())

		function click_outside(e) {
				/// is also called when touch released 0.1s after showModel --> coord - 10px
				if (e.target.id === 'effectPopup') {
					dialog.close(e)
				}
		}

		function remove_effect(e) {
				send_request('instruct', {instruct: 'REMOVE', subject: view.persona.ID, target: effect.ID})
				dialog.close(e)
		}

		function suspend_effect(e) {
				send_request('instruct', {instruct: 'SUSPEND', subject: view.persona.ID, target: effect.ID})
				dialog.close(e)
		}

</script>


<!------------------------------- HTML ------------------------------------->

<dialog id=effectPopup bind:this={dialog} style:left="{coord.x}px" style:top="{coord.y}px" style:--hue="{impactHue[effect.kind]}"
				onclose={() => view.close_dialog()} onclick={click_outside} >
	<h3 class="name">{effect.name}</h3>
	{#if cause && cause.actor !== effect.affected}
		<span>durch {cause.action} von {cause.actor}</span>
	{/if}
	<details>
		<summary>{effect.summary}</summary>
		{effect.descript}
	</details>
	<!-- params list -->
	<div class="params">
		<span class="doublespan">Effektstärke</span>
		<span class="modValue">{effect.magnitude}</span>
		{#if effect.ZUB === 'DamageEffect'}
			<Input field='damage' value={effect.damage} type=number separate disabled />
			<span class="modValue">/ {effect.damage - (effect.healed ?? 0)}</span>
			{#if effect.healed}
				<Input field='healed' value={-effect.healed} type=number separate disabled />
				<span />
			{/if}
		{/if}
		{#each Object.entries(effect.params ?? {}) as [key,val]}
			{@const modValue = effect.mods[key]}
			<Input field={key} value={val} type=number separate/>
			<span class="modValue">{(Number.isInteger(modValue)) ? bonusToString(modValue) : modValue}</span>
		{/each}
	</div>
	<!-- progress indicator -->
	{#if effect.begin >= 0}
		<div class="progress">
			<div>{timestamp(effect.begin)}</div>
			<div class="progress-bar">
				<div class="progress-indicator" style="background: linear-gradient(to right, transparent {progress}%, {effcolor} {progress}%)"></div>
				<div class="progress-bar-background"></div>
			</div>
			<div>{(user.isMaster) ? timestamp(effect.end - 1) : "??"}</div>
		</div>
	{/if}
	<hr/>
	{#if modal && (user.isMaster || ['Hidden', 'Watchful'].includes(effect.type))}
		<button class="btn-primary btn-primary-circle icon-trash-arrow-up"
						onclick={remove_effect}>
			Remove
		</button>
		{#if effect.ZUB === 'DynamicEffect'}
			<button class="btn-primary btn-primary-circle icon-trash-arrow-up"
							onclick={suspend_effect}>
				Suspend
			</button>
		{/if}
	{/if}

</dialog>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#effectPopup
		position: absolute
		max-width: 240px
		border: colors.$primary 2px solid
		border-radius: 5px
		margin: 0
		padding: 8px
		color: colors.$white
		background-color: #444
		box-shadow: 2px 2px 30px lightgrey
		transition: transform 0.2s, opacity 0.2s
		list-style: none
		overflow: hidden

	.name
		margin: 0
		padding: 8px
		width: 100%
		background-color: hsl(var(--hue) 50% 50%)
		text-align: center
		font-size: larger
		font-weight: bold

	/* description of the effect, opened by clicking its summary */
	details
		max-width: 500px
		padding: 16px 8px

	summary
		display: flex
		font-weight: bold
		cursor: pointer

		&::after
			content: "\f059"
			font-family: 'Font Awesome 6 Free'
			font-weight: 400
			filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.65))
			padding-left: 8px

	details[open] > summary::after
		content: "\f078"

	.params
		display: grid
		grid-template-columns: auto 6ch 6ch
		column-gap: 1ch

	.modValue
		font-size: larger
		text-align: right
		padding-top: 2px

	.progress
		display: flex
		flex-flow: row nowrap
		gap: 5px
		padding: 10px 0

	.progress-bar
		position: relative
		overflow: hidden
		width: 100%

	.progress-indicator,
	.progress-bar-background
		position: absolute
		top: 0
		left: 0
		width: 100%
		height: 100%
		display: flex
		align-items: center
		justify-content: center

	.progress-indicator
		z-index: 1

	.progress-bar-background
		background: colors.$grey-30
		box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.3)


</style>
